export default __webpack_public_path__ + "static/media/screen5.8d47d80d.png";